module.exports = __webpack_public_path__ + "img/ic_dorbom_app_logo.e1201a24.png";